import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme: any) => ({
  backdrop: {
    backgroundColor: 'rgba(0,0,0,0.3)',
  },
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalPaper: {
    padding: 20,
    backgroundColor: 'white',
    alignSelf: 'center',
    width: '90%',
    maxHeight: '90%',
    overflowY: 'auto',
    maxWidth: 570,
    outline: 'none',
    borderRadius: 10,
  },
  modalHeader: {
    display: 'flex',
    flexDirection: 'row',
  },
  modalHeaderSides: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
  },
  modalHeaderCenter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 3,
  },
  modalHeaderBack: {
    justifyContent: 'flex-start',
  },
  modalHeaderClose: {
    justifyContent: 'flex-end',
  },
  description: {
    marginTop: 6,
    marginBottom: 10,
    textAlign: 'justify',
  },
  analysisTitle: {
    marginBottom: 15,
  },
  recommendedAnalysisTitle: {
    marginTop: 25,
  },
  icon: {
    marginRight: 15,
    height: '100%',
  },
  errorIcon: {
    fontSize: '1.5rem',
  },
  warnIcon: {
    fontSize: '1.2rem',
  },
  selectContainer: {
    display: 'flex',
    width: '100%',
    backgroundColor: '#EEEEEE',
    borderRadius: theme.new.sizings.border,
    padding: '0.1rem 0.4rem',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: -5,
    marginBottom: 15,
  },
  selectText: {
    marginRight: 'auto',
  },
}));
